<nb-card class="modal-full">
    <nb-card-header>Edit block</nb-card-header>

    <nb-card-body>
        <!--<div class="form-group">
            <nb-toggle status="info" [(ngModel)]="isStructuredBlock" (checkedChange)="toggleFormat()">Block structure</nb-toggle>
        </div>-->
        <!--model:{{_model | json}}-->
        <div *ngIf="_model?.type == 'text'">
            <multilang-editor [model]="_model.data" editMode="true" [htmlMode]="htmlMode" 
                [languages]="languages" [defaultLang]="defaultLang"></multilang-editor>
        </div>
        <div *ngIf="_model?.type == 'dialog'">
            <app-editor-dialog [languages]="languages" [characters]="characters" [model]="_model" 
                [gameId]="gameId" [templateId]="templateId"></app-editor-dialog>
        </div>
        <div *ngIf="_model?.type == 'media'">
            <app-editor-media [languages]="languages" [model]="_model" 
                [gameId]="gameId" [templateId]="templateId"></app-editor-media>
        </div>
        <!--<div id="editor-js" class="m-5" [hidden]="!isStructuredBlock"></div>-->


        <!--data:{{_model | json}}-->
    </nb-card-body>
    <nb-card-footer>
        <div class="row">
            <button class="cancel" nbButton status="danger" (click)="cancel()">Cancel</button>
            <button nbButton status="success" (click)="save()">Validate</button>
        </div>
    </nb-card-footer>
</nb-card>